import { Link } from "react-router-dom";


function SlideShow(props) {
    return (
        <Link to={`/SingleProduct/${props.product.id}`}>
        <div className="bg-white lg:max-w-[90%] max-w-[95%]  container mx-auto  flex border-[3px] border-violet-100 shadow-lg  rounded-xl h-[200px] md:h-[500px]  md:mt-10 mt-5">

            <div className="md:w-[40%] w-[30%] md:p-4 p-2 h-full  overflow-hidden flex justify-center items-center">
                <img className="w-[100%] max-h-[100%] object-contain" src={props.product.image} />
            </div>
            <div className="md:p-10 p-2 max-w-[70%] flex flex-col justify-between">
                <h1 className="font-bold md:text-4xl text-xl text-violet-900">{props.product.category.toString().toUpperCase()}</h1>
                <h2 className="lg:text-3xl text-md leading-5 md:overflow-text-6 overflow-text-3">{props.product.title}</h2>
                <h3 className="hidden md:block">{props.product.description}</h3>
                <div className="md:text-2xl text-md flex flex-col">
                    <span className="w-fit md:text-xl text-sm rounded pl-2 bg-violet-500  flex justify-center items-center align-center content-center md:mb-3 mb-1">{props.product.rating.rate} ⭐</span>
                    <span className="text-violet-800">{props.product.rating.count} Happy Customers <span className="hidden md:inline">and counting</span></span>
                </div>
                <div className="md:text-3xl text-lg">
                    For Just Rs.<span className="text-green-700"> {props.product.price}</span> Only
                </div>
            </div>

        </div>
        </Link>
    );
}

export default SlideShow;